import React from "react";

import Header from "../navbar/navbar";
import Footer from "../Footer/footer";
import Spacer from "../spacer-for-header/spacer";
import ContactHero from "../Contact Section/contact Hero";
export default function Contact() {
  return (
    <>
      <Header />
      <Spacer />
      <ContactHero />
      <Footer />
    </>
  );
}
